import authInstance from "../Interceptor";

export const ViewAllCountryEffect = () => {
  return authInstance.get(`/common/getCountry`);
};
export const ViewAllStateEffect = (id) => {
  return authInstance.get(`/common/getState/${id}`);
};

export const ViewAllCityEffect = (id) => {
  return authInstance.get(`/common/getCities/${id}`);
};
